module.exports = __webpack_public_path__ + "static/media/epargn-offer.c1d9fb50.png";